var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "title" } }, [
    _c(
      "p",
      {
        staticClass: "display-1 text--darken-2 bold-title",
        staticStyle: { "text-align": "center" },
        attrs: { id: "override-font-family" }
      },
      [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]
    ),
    _vm._v(" "),
    _vm.subtitle
      ? _c(
          "p",
          {
            staticClass: "subheading text--darken-1",
            staticStyle: { "text-align": "center" }
          },
          [_vm._v("\n    " + _vm._s(_vm.subtitle) + "\n  ")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }